import React from 'react';
import NotLoggedInLayout from './utilities/layouts/NotLoggedInLayout';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { styleBreakMobile } from './utilities/layouts/Globals';
import { useHistory } from 'react-router-dom';
import { PATH_REQUEST_PASSWORD_RESET } from '../containers/RoutePaths';

const useStyles = makeStyles(theme => ({
    contentTitle: {
        marginBottom: theme.spacing(2),
        [styleBreakMobile(theme)]: {
            marginBottom: theme.spacing(1),
        },
    },
    emailText: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(1),
    },
    emailInput: {
        width: '380px',
        [styleBreakMobile(theme)]: {
            width: '100%',
        },
    },
}));

export default function RestLinkExpiredPage() {
    const classes = useStyles();
    const buttonText = 'Request a Reset Link';
    const history = useHistory();

    const onButtonClick = () => {
        history.push(PATH_REQUEST_PASSWORD_RESET);
    };

    const content = (
        <div>
            <Typography variant="h1" component="div" className={classes.contentTitle}>
                Reset Link Expired
            </Typography>
            <Typography variant="body1" component="div">
                This link has expired because it has been more than 24 hours since we have created your reset link.
            </Typography>
            <Typography variant="body1" component="div">
                To receive a new reset link, please click on the button below.
            </Typography>
        </div>
    );

    return <NotLoggedInLayout onClick={onButtonClick} buttonText={buttonText} content={content} />;
}
